export const PRODUCTION_TRADE_STATUS = {
  SENT_FOR_APPROVAL: {
    id: "sent_for_approval",
    label: "Sent For Approval",
    color: "!text-blue-500",
  },
  APPROVED: { id: "approved", label: "Approved", color: "!text-green-500" },
  REJECTED: { id: "rejected", label: "Rejected", color: "!text-red-500" },
  CANCELLED: { id: "cancelled", label: "Cancelled", color: "!text-red-500" },
  IN_PROGRESS: {
    id: "in_progress",
    label: "In Progress",
    color: "!text-blue-500",
  },
  COMPLETED: { id: "completed", label: "Completed", color: "!text-green-500" },
}
